export default __webpack_public_path__ + "static/media/arrow-grey-left.0e376a51.svg";